import { FC, KeyboardEvent } from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import PerfectScrollbar from 'react-perfect-scrollbar'

import { RelatedBrandsProps } from "./types";
import { selectAuthLoadingRelatedBrands, selectAuthRelatedBrands } from "../../store/selectors/auth";
import { LogoResponse } from "../../store/brands/types";
import BrandLogo from "../BrandLogo/BrandLogo";

import styles from "./RelatedBrands.module.css";
import 'react-perfect-scrollbar/dist/css/styles.css';



const RelatedBrands: FC<RelatedBrandsProps> = ({ className, onSelect }) => {
  const loading = useSelector(selectAuthLoadingRelatedBrands);
  const relatedBrands = useSelector(selectAuthRelatedBrands);

  if (!Array.isArray(relatedBrands) || (!relatedBrands || relatedBrands.length === 0)) return null;

  const handleKeyDown = (event: KeyboardEvent<HTMLElement>, brand: LogoResponse) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelect(brand);
    }
  };

  return (
    <PerfectScrollbar 
      className={classNames(styles.related, loading && styles.loading, className)}
      role="list"
      aria-label="Related brands"
    >
      {relatedBrands.map((brand) => (
        <article 
          className={styles.related__item} 
          key={brand.domain} 
          onClick={() => onSelect(brand)}
          onKeyDown={(e) => handleKeyDown(e, brand)}
          role="listitem"
          tabIndex={0}
          aria-label={`Select brand ${brand.name}`}
        >
          <BrandLogo
            logoUrl={brand.logo_url}
            name={brand.name}
            size="small"
            className={styles.related__logo}
          />
          <p className={styles.related__name}>{brand.name}</p>
        </article>
      ))}
    </PerfectScrollbar>
  );
};

export default RelatedBrands;
